export const mockServices = [
  {
    id: 1,
    title: "Intégration de Solutions IT",
    description: "Solutions complètes d'intégration de systèmes informatiques pour optimiser votre infrastructure technologique.",
    icon: "Server",
    details: "Nous concevons et déployons des solutions d'intégration sur mesure qui unifient vos systèmes existants, améliorent l'efficacité opérationnelle et réduisent les coûts. Notre expertise couvre l'intégration cloud, les migrations de données et l'automatisation des processus."
  },
  {
    id: 2,
    title: "Développement Logiciel",
    description: "Création d'applications personnalisées adaptées à vos besoins métier spécifiques.",
    icon: "Code",
    details: "Notre équipe de développeurs expérimentés crée des solutions logicielles robustes et évolutives. Du développement web aux applications mobiles, nous utilisons les dernières technologies pour transformer vos idées en produits fonctionnels."
  },
  {
    id: 3,
    title: "Cloud Computing",
    description: "Migration et gestion de vos infrastructures vers le cloud pour une flexibilité maximale.",
    icon: "Cloud",
    details: "Exploitez la puissance du cloud avec nos services de migration, d'optimisation et de gestion. Nous travaillons avec AWS, Azure et Google Cloud pour offrir des solutions cloud sécurisées et performantes."
  },
  {
    id: 4,
    title: "Cybersécurité",
    description: "Protection avancée de vos données et systèmes contre les menaces numériques.",
    icon: "Shield",
    details: "Sécurisez votre entreprise avec nos solutions de cybersécurité complètes. Audits de sécurité, détection des menaces, protection des données et formation du personnel pour une défense multicouche."
  },
  {
    id: 5,
    title: "Conseil IT",
    description: "Expertise stratégique pour orienter vos décisions technologiques et maximiser votre ROI.",
    icon: "Lightbulb",
    details: "Nos consultants expérimentés vous accompagnent dans votre transformation digitale. Nous analysons vos besoins, recommandons les meilleures solutions et vous guidons à chaque étape de mise en œuvre."
  },
  {
    id: 6,
    title: "Support Technique",
    description: "Assistance technique 24/7 pour garantir la continuité de vos opérations.",
    icon: "Headphones",
    details: "Notre équipe de support dédiée assure la maintenance et le dépannage de vos systèmes. Support réactif, résolution proactive des problèmes et accompagnement continu pour une tranquillité d'esprit totale."
  }
];

export const mockBlogPosts = [
  {
    id: 1,
    title: "L'Intelligence Artificielle au Service de l'Entreprise",
    excerpt: "Découvrez comment l'IA transforme les processus métier et crée de nouvelles opportunités de croissance.",
    author: "Marie Dubois",
    date: "2025-08-15",
    category: "Innovation",
    image: "https://images.unsplash.com/photo-1605647540924-852290f6b0d5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc2OTI5MzM4OXww&ixlib=rb-4.1.0&q=85",
    readTime: "5 min"
  },
  {
    id: 2,
    title: "Cybersécurité : Les Menaces de 2025",
    excerpt: "Analyse des principales menaces cybersécurité et stratégies de protection pour votre entreprise.",
    author: "Jean Martin",
    date: "2025-08-10",
    category: "Sécurité",
    image: "https://images.pexels.com/photos/27243718/pexels-photo-27243718.jpeg",
    readTime: "7 min"
  },
  {
    id: 3,
    title: "Migration Cloud : Guide Pratique",
    excerpt: "Les étapes essentielles pour une migration cloud réussie sans interruption de service.",
    author: "Sophie Bernard",
    date: "2025-08-05",
    category: "Cloud",
    image: "https://images.unsplash.com/photo-1606211105533-0439bfecce21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc2OTI5MzM4OXww&ixlib=rb-4.1.0&q=85",
    readTime: "6 min"
  },
  {
    id: 4,
    title: "Optimisation de l'Infrastructure IT",
    excerpt: "Techniques avancées pour améliorer les performances et réduire les coûts opérationnels.",
    author: "Pierre Lefebvre",
    date: "2025-07-28",
    category: "Infrastructure",
    image: "https://images.unsplash.com/photo-1508361727343-ca787442dcd7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc2OTI5MzM4OXww&ixlib=rb-4.1.0&q=85",
    readTime: "8 min"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Alexandre Durand",
    company: "TechCorp Solutions",
    role: "Directeur IT",
    content: "IntegralTech a transformé notre infrastructure IT. Leur expertise et professionnalisme sont exceptionnels. Migration cloud réussie en temps record.",
    rating: 5,
    image: "https://images.unsplash.com/photo-2507679799987-c73779587ccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NjkyOTMzOTR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Catherine Moreau",
    company: "Innovate Plus",
    role: "CEO",
    content: "Un partenaire de confiance pour notre transformation digitale. Équipe réactive, solutions innovantes et résultats mesurables.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NjkyOTMzOTR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Marc Rousseau",
    company: "DataSecure",
    role: "RSSI",
    content: "Grâce à IntegralTech, notre sécurité informatique est au top niveau. Audit complet et mise en place de solutions de pointe.",
    rating: 5,
    image: "https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg"
  }
];

export const mockTeam = [
  {
    id: 1,
    name: "DAH Odilon",
    role: "Directeur Général",
    image: "https://images.unsplash.com/photo-2507679799987-c73779587ccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NjkyOTMzOTR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "DIAPA Assétou",
    role: "Direction Commerciale",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NjkyOTMzOTR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "DAH Hischame",
    role: "Direction Technique",
    image: "https://images.pexels.com/photos/2381069/pexels-photo-2381069.jpeg"
  },
  {
    id: 4,
    name: "DAH Imran",
    role: "Direction Contrôle Qualité et Approvisionnement",
    image: "https://images.unsplash.com/photo-2507679799987-c73779587ccf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NjkyOTMzOTR8MA&ixlib=rb-4.1.0&q=85"
  }
];

export const mockProjects = [
  {
    id: 1,
    name: "Migration Cloud Enterprise",
    client: "TechCorp Solutions",
    status: "En cours",
    progress: 75,
    startDate: "2025-06-01",
    dueDate: "2025-09-15",
    description: "Migration complète de l'infrastructure vers AWS avec optimisation des coûts."
  },
  {
    id: 2,
    name: "Développement Application Mobile",
    client: "Innovate Plus",
    status: "Terminé",
    progress: 100,
    startDate: "2025-03-15",
    dueDate: "2025-07-30",
    description: "Application mobile iOS et Android pour la gestion de projet collaborative."
  },
  {
    id: 3,
    name: "Audit Cybersécurité",
    client: "DataSecure",
    status: "Planifié",
    progress: 10,
    startDate: "2025-09-01",
    dueDate: "2025-10-30",
    description: "Audit complet de sécurité et mise en place de protocoles de protection avancés."
  }
];

export const mockStats = [
  {
    value: "250+",
    label: "Projets Réalisés"
  },
  {
    value: "150+",
    label: "Clients Satisfaits"
  },
  {
    value: "15+",
    label: "Années d'Expérience"
  },
  {
    value: "98%",
    label: "Taux de Satisfaction"
  }
];